const getters = {
  userInfo: state => state.userInfo,
  searchText: state => state.search
}
export default getters
